import React from 'react';
const CardTitle = props => {
    return (
        <h2 className="font-weight-light">
            {props.children}
        </h2>
    )
};
export default CardTitle